<script>
  import {beforeUpdate, onDestroy, onMount} from "svelte";
  import {store} from "./Utils/stores";
  import VideoYTElement from "./VideoYTElement.svelte";
  import {localVideoLink, openLink} from "./services/localServices";
  import {isOffline} from "./services/configService";
  import VideoLocalElement from "./VideoLocalElement.svelte";
  import ShareThisVideoView from "./ShareThisVideoView.svelte";

  export let video
  export let title
  let video_component = null;
  let update_source = true;
  let local_video = true;

  function vtutorial_link(avideo) {
    if (avideo && avideo.slug.current) {
      return `https://storage.vectric.com/tutorials/v12.0/${avideo.slug.current}.vtutorial`;
    } else {
      return "";
    }
  }

  function installLink(avideo) {
    if (avideo && avideo.slug.current) {
      return `vectric://install?tutorial=${vtutorial_link(avideo)}`;
    }
    return "";
  }

  function downloadLink(avideo) {
    return vtutorial_link(avideo);
  }

  function isLocalVideoFound(video) {
    // Update the video source
    // Check for local file existence by loading and throwing an error
    // if an error occurs then we will go back to Youtube
    local_video = false;
    if (isOffline()) {
      let v = document.createElement('VIDEO');
      v.addEventListener('error', function (e) {
        local_video = false;
      });
      v.addEventListener('loadeddata', function () {
        local_video = true;
      });
      v.src = localVideoLink(video);
    } else {
      local_video = false;
    }
  }

  function update_video_source() {
    // Update the video source
    // Check for local file existence by loading and throwing an error
    // if an error occurs then we will go back to Youtube
    local_video = false;
    if (isOffline()) {
      let v = document.createElement('VIDEO');
      v.addEventListener('error', function (e) {
        local_video = false;
      });
      v.addEventListener('loadeddata', function () {
        local_video = true;
      });
      v.src = localVideoLink(video);
    } else {
      local_video = false;
    }
  }


  function get_open_link(avideo) {
    return openLink(avideo);
  }

  function get_time_percentage(avideo, bookmark) {
    if (avideo.videoDuration !== undefined) {
      let thetime = bookmark.bookmarkTime.minutes * 60;
      let thetotaltime = thetime + bookmark.bookmarkTime.seconds;

      let videotime = avideo.videoDuration.minutes * 60;
      let totalvideotime = videotime + avideo.videoDuration.seconds;

      return (thetotaltime * 100) / totalvideotime;
    }
  }

  function get_component(local) {
    if (local) {
      return VideoLocalElement;
    } else {
      console.log("Video component is YT")
      return VideoYTElement;
    }
  }


  function set_player_time(avideo, bookmark) {
    let thetime = bookmark.bookmarkTime.minutes * 60;
    let thetotaltime = thetime + bookmark.bookmarkTime.seconds;
    video_component.set_player_time(thetotaltime);
  }


  beforeUpdate(() => {
    if (update_source) {
      update_source = false;
      update_video_source();
    }
  })

  onDestroy(store.subscribe(value => {
    local_video = false;
    update_source = true;
  }));

  $: {
    isLocalVideoFound(video)
  }

  let bookmarksState = false

  function toggle_bookmarks() {
    if(window.innerWidth < 768) {
      bookmarksState = !bookmarksState
    }
  }


</script>

<div>
  <!-- Description -->
  <div class="vec-flex vec-justify-center">
    {#if video.youtube}
      <div class="vec-w-full vec-h-full vec-aspect-[16/9]">
          {#key video.youtube}
            <svelte:component bind:this={video_component}
                              this={get_component(local_video)}
                              video={video}
                              on:video-ended on:soft-video-end
            />
          {/key}
      </div>
    {:else}
      <div class=" col-12 py-5 mt-2  bg-light">
        <h4 class="vec-text-center my-5 py-5">Video could not be found</h4>
      </div>
    {/if}
  </div>

  <!-- Actions -->
  <div class="vec-bg-darkGrey vec-flex vec-items-center vec-p-2 vec-space-x-2 vec-rounded-bl vec-rounded-br vec-hidden lg:vec-block">
    {#if local_video}
        <a target="_parent" href={get_open_link(video)}>
          <button type="button" class="vec-btn">Open</button>
        </a>
    {/if}

    {#if !local_video}
        <a target="_parent" href={installLink(video)}>
          <button type="button" class="vec-btn">Install</button>
        </a>
        <a target="_parent" href={downloadLink(video)}>
          <button type="button" class="vec-btn">Download</button>
        </a>
    {/if}
  </div>
    <div class="vec-w-full vec-flex vec-my-4 sm:vec-items-center vec-flex-col sm:vec-flex-row">
      <h3 class="sm:vec-mr-3 vec-text-lg vec-flex-grow">
        {title}
      </h3>
    <ShareThisVideoView video={video}/>
    </div>
    <div class="vec-py-2 vec-text-sm">
      {@html video.longDescription}
    </div>

  {#if video.bookmarks && video.bookmarks.length > 0}
  
    <div id="bookmarks" class:open-bookmarks={bookmarksState} class="vec-flex md:vec-mt-8 vec-absolute md:vec-relative vec-top-0 vec-bg-white vec-h-full vec-shadow-lg md:vec-shadow-none vec-rounded-r-xl md:vec-rounded-none">
      <div id="bookmarksTab" class="cursor-pointer md:vec-hidden vec-absolute vec-left-[100%] vec-top-[110px] vec-z-1 vec-px-3 vec-py-1 vec-bg-white vec-shadow-lg vec-origin-bottom-left vec-rotate-90 vec-text-nowrap vec-text-right vec-rounded-t vec-text-xs" on:click={() => {
        toggle_bookmarks();
      }}>
      {#if bookmarksState}Hide{:else}View{/if}&nbsp;Bookmarks</div>
      <div class="vec-bookmarks-content vec-w-full vec-h-full vec-overflow-y-auto vec-p-5 md:vec-p-0 vec-relative vec-z-2 vec-bg-white vec-rounded-r-xl md:vec-rounded-none">
        <h4 class="vec-mb-2">Bookmarks</h4>
        {#if video.videoDuration}
        <div class="vec-hidden md:vec-block">
          <svg id='timeline' height='40' width='100%'>
            <line x1='0' y1='20' x2='100%' y2='20' style='stroke:#c5c5c5;stroke-width:2'></line>
            <line x1="0" y1="40" x2="0" y2="0" style="stroke:#505050;stroke-width:6"></line>
            {#each video.bookmarks as bookmark,i}
              <a href="#" on:click|preventDefault={set_player_time(video, bookmark)}>
                <circle cx='{get_time_percentage(video, bookmark)}%' cy="20" r="10" stroke-width="3"
                        fill="#505050"></circle>
                <text x='{get_time_percentage(video, bookmark)}%' y="20" text-anchor="middle"
                      alignment-baseline="middle" style="fill:white;"
                      font-size="14px">{i + 1}</text>
              </a>
            {/each}
            <line x1="100%" y1="40" x2="100%" y2="0" style="stroke:#505050;stroke-width:6"></line>
          </svg>
        </div>
        {/if}
        <ol class="bookmark-list vec-mt-3 vec-pl-0 vec-list-style-none vec-text-sm">
          {#each video.bookmarks as bookmark,i}
            <li class="vec-relative vec-pl-7 vec-py-3 md:vec-py-2 vec-cursor-pointer" on:click={set_player_time(video, bookmark),toggle_bookmarks()}>
              <span class="vec-font-bold vec-absolute vec-top-3 md:vec-top-2 vec-left-0">{i + 1}.</span>{bookmark.bookmarkName}
            </li>
          {/each}
        </ol>
      </div>
    </div>
  {/if}

</div>

<style>
    .bookmark-list {
        columns: 1;
    }

    @media only screen and (min-width: 768px) {
      .bookmark-list {
        columns: 2;
      }
    }
    @media only screen and (max-width: 767px) {
    #bookmarks {
      right:100%;
      width:80%;
      transition: right 0.3s ease-out;
    }

    #bookmarks.open-bookmarks {
      right:20%;
      z-index:2;
    }

    #bookmarksTab {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }
  }


</style>

